import React from 'react';

import { useCustomerLoyalty } from '@/hooks/api/customer';

import LoyaltySelector, { schemes } from './loyaltySelector';

const CustomerLoyalty = () => {
    const loyaltyPrograms = useCustomerLoyalty();

    return (
        <>
            {Object.entries(loyaltyPrograms ?? [])
                .filter(([schemeId]) =>
                    schemes.includes(schemeId)
                )
                .map(([schemeId]) => (
                    <LoyaltySelector
                        key={schemeId}
                        schemeId={schemeId}
                    />
                ))}
        </>
    );
};

export default CustomerLoyalty;